const mutations = {
  SET_MY_SUBSCRIPTION(state, sub) {
    state.mySubscription = sub;
  },
  SET_QUEUED_SUBSCRIPTIONS(state, subscriptions) {
    state.queuedSubscriptions = subscriptions;
  },
  SET_MY_PROPERTIES(state, { data, meta }) {
    state.myProperties = data;
    state.myPropertiesMeta = meta;
  },
  UPDATE_MY_PROPERTY(state, property) {
    const idx = state.myProperties.findIndex((p) => p.id === property.id);
    if (idx !== -1) state.myProperties.splice(idx, 1, property);
  },
  SET_ADMIN_SUBSCRIPTIONS(state, { data, meta }) {
    state.adminSubscriptions = data;
    state.adminSubscriptionsMeta = meta;
  },
  UPDATE_SUBSCRIPTION(state, sub) {
    const idx = state.adminSubscriptions.findIndex((s) => s.id === sub.id);
    if (idx !== -1) state.adminSubscriptions.splice(idx, 1, sub);
  },
};

export default mutations;
